module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b3a2f0aaa964d2265872d3f32c848001.png";